import React, { useReducer } from "react";
import axios from "axios";
import FulfillmentContext from "./FulfillmentContext";
import FulfillmentReducer from "./FulfillmentReducer";
import {
  SET_LOADING,
  GET_UNFULFILL,
  GET_UNFULFILL_BY_ID,
  GET_UNFULFILL_ERROR,
} from "../types";

const FulfillmentState = (props) => {
  const initialState = {
    loading: false,
    unfulfill: null,
    unfulfillAdded: null,
    error: null,
  };

  const [state, dispatch] = useReducer(FulfillmentReducer, initialState);

  // Set Loading
  const setLoading = () =>
    dispatch({
      type: SET_LOADING,
    });

  // Get Unfulfill Records
  const getUnfulfill = async (from, to, order_id) => {
    if (order_id) {
      try {
        const res = await axios.post("/api/fulfillment/get-unfulfill", {
          order_id: order_id,
        });
        dispatch({
          type: GET_UNFULFILL_BY_ID,
          payload: res.data,
        });
      } catch (err) {
        dispatch({
          type: GET_UNFULFILL_ERROR,
          payload: err.response,
        });
      }
    }
    if (from && to) {
      setLoading(true);
      try {
        const res = await axios.post("/api/fulfillment/get-unfulfill", {
          dateFrom: from,
          dateTo: to,
        });
        dispatch({
          type: GET_UNFULFILL,
          payload: res.data,
        });
      } catch (err) {
        dispatch({
          type: GET_UNFULFILL_ERROR,
          payload: err.response,
        });
      }
    }
  };

  return (
    <FulfillmentContext.Provider
      value={{
        loading: state.loading,
        unfulfill: state.unfulfill,
        unfulfillAdded: state.unfulfillAdded,
        error: state.error,
        setLoading,
        getUnfulfill,
      }}
    >
      {props.children}{" "}
    </FulfillmentContext.Provider>
  );
};

export default FulfillmentState;
